export interface UserUpdateDetailsRequest {
    homePhoneNumber: string;
    mobilePhoneNumber: string;
}
